/**
 * 色ボタンの重複を削除する
 * @param {HTMLElement} card
 */
function removeDuplicateColorButtons (card) {
    // 色のボタン一覧を取得
    const $colorButtons = card.querySelectorAll("button.card-color__btn");

    // ボタン一覧からdata-availableがtrueのものを抽出する。data-srcが同じボタンが複数ある場合は1点のみ抽出。
    const uniqueButtons = [];
    const seenSrc = [];

    $colorButtons.forEach(function (button) {
        if (button.dataset.available === "true") {
            const src = button.dataset.src;
            if (!seenSrc.includes(src)) {
                seenSrc.push(src);
                uniqueButtons.push(button);
            }
        }
    });

    // data-availableがfalseでuniqueButtonsに未追加のボタンを抽出。data-srcが同じボタンが複数ある場合は1点のみ抽出。
    $colorButtons.forEach(function (button) {
        if (button.dataset.available === "false") {
            const src = button.dataset.src;
            if (!seenSrc.includes(src)) {
                seenSrc.push(src);
                uniqueButtons.push(button);
            }
        }
    });

    //重複を削除したボタンを再度設定
    const $colorContent = card.querySelector(".card-color__content");
    if($colorContent) {
        $colorContent.innerHTML = ""; // リセット

        uniqueButtons.forEach(function (button) {
            $colorContent.appendChild(button);
        });

        $colorContent.style.display = "flex";
    }
}

/**
 * 色ボタンのクリックイベントを設定する
 * @param {HTMLElement} card
 */
function initEventColorButtons(card) {
    // 新しいcolorボタンを取得
    const $colorButtons = card.querySelectorAll("button.card-color__btn");

    // 有効な全てのbuttonからactiveクラスを削除
    const clearActive = (function () {
        $colorButtons.forEach(function (button) {
            button.classList.remove("active");
        });
    });

    // 各colorボタンにクリックイベントを設定
    $colorButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            e.preventDefault();

            const src = this.dataset.src;
            const srcset = this.dataset.srcset;

            if(src && srcset) {
                const img = card.querySelector(".media-img");

                if(img) { // 画像のsrcとsrcsetを更新
                    img.setAttribute("src", src);
                    img.setAttribute("srcset", srcset);
                }
            }

            clearActive();
            this.classList.add("active");
        });
    });
}

function initColorButtons() {
    // card--mediaクラスを持つ全ての要素を取得
    const $mediaCards = document.querySelectorAll(".card--media");
    $mediaCards.forEach(function (card) {
        removeDuplicateColorButtons(card);
        initEventColorButtons(card);
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initColorButtons();
});